import { useState, useEffect, useRef } from "react";
import {
  Grid,
  Typography,
  CircularProgress,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  TextField,
  makeStyles,
} from "@material-ui/core";
import { AddOutlined } from "@material-ui/icons";
import { useFetch } from "../../features/customHooks/useFetch";
import MessageCard from "../../components/messageCard/MessageCard";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    zIndex: 1000,
  },
  messagesGrid: {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 20,
  },
  fg1: { flexGrow: 1 },
}));

const Messages = (props) => {
  const classes = useStyles();

  const initialGetParams = {
    method: "get",
    url: "/message",
  };

  const [getFetchState, setGetFetchParams] = useFetch(initialGetParams);
  const [messageFetchState, setMessageFetchParams] = useFetch();
  const [deleteFetchState, setDeleteFetchParams] = useFetch();

  const messageRef = useRef();

  const [deleteDialog, setDeleteDialog] = useState({ id: null });
  const handleDeleteDialogOpen = (id) => setDeleteDialog({ id: id });
  const handleDeleteDialogClose = () => setDeleteDialog({ id: null });

  const [messageDialog, setMessageDialog] = useState({ id: null, type: null });
  const handleMessageDialogOpen = (id, type) => setMessageDialog({ id, type });
  const handleMessageDialogClose = () => setMessageDialog({ id: null, type: null });

  const handleMessage = () => {
    if (messageRef.current.value) {
      var params = {};
      if (messageDialog.type === "new") {
        params = {
          method: "post",
          url: "/message",
          data: { text: messageRef.current.value },
        };
      } else if (messageDialog.type === "edit") {
        params = {
          method: "put",
          url: "/message/" + messageDialog.id,
          data: { text: messageRef.current.value },
        };
      }
      setMessageFetchParams(params);
    } else handleMessageDialogClose();
  };

  const handleEditMessage = (id, text) => {
    handleMessageDialogOpen(id, "edit");
    setTimeout(() => {
      if (messageRef.current) messageRef.current.value = text;
    }, 200);
  };

  const handleDeleteMessage = () => {
    const params = {
      method: "delete",
      url: "/message/" + deleteDialog?.id,
    };
    setDeleteFetchParams(params);
  };

  useEffect(() => {
    if (!messageFetchState.loading && !messageFetchState.error && messageFetchState.data) {
      handleMessageDialogClose();
      messageRef.current.value = null;
      setGetFetchParams(initialGetParams);
    }
    if (!messageFetchState.loading && messageFetchState.error) console.log("error");
  }, [messageFetchState]);

  useEffect(() => {
    if (!deleteFetchState.loading && !deleteFetchState.error && deleteFetchState.data) {
      handleDeleteDialogClose();
      setGetFetchParams(initialGetParams);
    }
    if (!deleteFetchState.loading && deleteFetchState.error) console.log("error");
  }, [deleteFetchState]);

  return (
    <Grid container direction='column' className={classes.messagesGrid}>
      <Grid item xs={12}>
        {/* <Fab color='primary' className={classes.fab} onClick={handleNewMessageDialogOpen}>
        <Add />
      </Fab> */}

        <Grid container justifyContent='flex-start' alignItems='center'>
          <Typography
            style={{
              fontSize: 30,
              fontWeight: 800,
            }}
          >
            پیام‌ها
          </Typography>

          <div className={classes.fg1} />

          <Button
            variant='contained'
            color='primary'
            endIcon={<AddOutlined />}
            onClick={() => handleMessageDialogOpen(null, "new")}
          >
            ایجاد پیام
          </Button>
        </Grid>

        <Grid
          container
          direction='row'
          alignItems='center'
          justifyContent='center'
          style={{ marginBottom: 10, marginTop: 20 }}
        >
          {getFetchState?.loading ? (
            <CircularProgress style={{ color: "#757575" }} />
          ) : getFetchState?.data?.data?.length > 0 ? (
            getFetchState?.data?.data?.map((message) => (
              <MessageCard
                key={message.id}
                message={message}
                deleteMessage={(id) => handleDeleteDialogOpen(id)}
                editMessage={handleEditMessage}
              />
            ))
          ) : (
            <Chip variant='outlined' label='پیامی برای نمایش وجود ندارد!' style={{ margin: 20 }} />
          )}
        </Grid>

        <Dialog open={deleteDialog.id} onClose={handleDeleteDialogClose} maxWidth={"xs"} fullWidth>
          <DialogTitle id='form-dialog-title'>تایید حذف</DialogTitle>
          <DialogContent>
            <Typography>آیا مایل به حذف این پیام هستید؟</Typography>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={deleteFetchState?.loading}
              onClick={handleDeleteDialogClose}
              variant='text'
              color='primary'
            >
              لغو
            </Button>
            <Button
              disabled={deleteFetchState?.loading}
              onClick={handleDeleteMessage}
              color='secondary'
              variant='contained'
            >
              {deleteFetchState?.loading ? <CircularProgress size={24} /> : "حذف پیام"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={messageDialog.type}
          onClose={handleMessageDialogClose}
          aria-labelledby='form-dialog-title'
          style={{ padding: 10 }}
          fullWidth
        >
          <DialogTitle id='form-dialog-title'>{messageDialog.type === "new" ? "پیام جدید" : "ویرایش پیام"}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              id='text'
              label='متن پیام'
              fullWidth
              variant='outlined'
              multiline
              rows='6'
              rowsMax='10'
              inputRef={messageRef}
              disabled={messageFetchState?.loading}
            />
          </DialogContent>
          <DialogActions>
            <Button
              disabled={messageFetchState?.loading}
              onClick={handleMessageDialogClose}
              variant='text'
              color='primary'
            >
              لغو
            </Button>
            <Button disabled={messageFetchState?.loading} onClick={handleMessage} color='secondary' variant='contained'>
              {messageFetchState?.loading ? (
                <CircularProgress size={24} />
              ) : messageDialog.type === "new" ? (
                "ارسال پیام"
              ) : (
                "ویرایش پیام"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </Grid>
  );
};

export default Messages;
